import React, {Component, Fragment} from 'react';
import ListaTabla from './Includes/ListaTabla';
import ModalProveedor from './Includes/ModalProveedor';
import {ProveedorService} from '../../../services/_Sis/ProveedorService/ProveedorService';
import {FieldsJs} from "../../../settings/General/General";
import {ReactLocalStorageService} from '../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import VistaVacia from "../../Include/VistaVacia/VistaVacia";
import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../settings/IntegrationNotistack/IntegrationNotistack";
import {BotonActualizarLista, CabeceraTituloPdfExcelLista} from "../../Include/MiniComponents/GlobalComponent";
import Paginacion from "../../Include/Paginacion/Paginacion";
import {HttpRequest} from "../../../settings/HttpRequest/HttpRequest";
import {CatService} from "../../../services/_Cat/CatService/CatService";
import FiltrosProveedor from "./Includes/FiltrosProveedor";


class Proveedor extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		this.state = {
			listar_cuenta_bancaria: [],
			
			filtro: {},
			
			paginacion: {
				total: null,
				page: 1,
				limit: this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			},
		};
		
		this.Listar();
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	RefreshList = () => {
		this.Listar();
	};
	
	HandleFiltro = (filtro) => {
		this.setState({
			filtro: filtro
		});
	};
	
	DefaultNumPag = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		return Cfg.paginacion_numero_registro ? Number(Cfg.paginacion_numero_registro) : 10;
	};
	
	DefaultRangos = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		let rangos = [5, 10, 15, 20];
		if (FieldsJs.Array(Cfg.paginacion_rangos)) {
			rangos = Cfg.paginacion_rangos;
		}
		return rangos;
	};
	
	Listar = () => {
		ProveedorService.Listar(this.state.filtro, this.state.paginacion).then((response) => {
			this.setState({
				listar_cuenta_bancaria: response.data,
				
				paginacion: {
					total: response.paginacion.total,
					page: response.paginacion.page,
					limit: response.paginacion.limit,
					rangos: this.DefaultRangos()
				}
			});
		}).catch((error) => {
			this.setState({
				listar_cuenta_bancaria: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	ListProveedor = () => {
		return new Promise((resolve, reject) => {
			CatService.ListProveedor().then((response) => {
				this.setState({
					cat_proveedor: response.data
				});
				resolve(response);
			});
		});
	};
	
	ListBanco = () => {
		return new Promise((resolve, reject) => {
			CatService.ListBanco().then((response) => {
				this.setState({
					cat_banco: response.data
				});
				resolve(response);
			});
		});
	};
	
	ListAreaProyecto = () => {
		return new Promise((resolve, reject) => {
			CatService.ListAreaProyecto().then((response) => {
				this.setState({
					cat_area_proyecto: response.data
				});
				resolve(response);
			});
		});
	};
	
	AplicarPaginacion = (data) => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: data.page || paginacion.page || null,
				limit: data.limit || paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	AplicarFiltros = () => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: 1,
				limit: paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	exportar = (item, archivo, auth) => {
		let filtro = {
			id_cuenta_bancaria: item.id_cuenta_bancaria || '',
			id_usuario_apoderado: item.id_usuario_apoderado || '',
		};
		console.log('EXPORTAR::: ', item);
		HttpRequest.export('cuentasbancarias', ['cuentas_bancarias'], {
			auth: auth,
			archivo: archivo,
			filtro: filtro
		}, false, false, false, archivo === "EXCEL")
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				
				<CabeceraTituloPdfExcelLista
					titulo={'Proveedores'}
					/*botonPDF={
						<Fragment>
							{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
								<BotonExportarListaPDF onClick={() => {
								
								}}/>
							) : ''}
						</Fragment>
					}
					botonEXCEL={
						<Fragment>
							{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
								<BotonExportarListaExcel onClick={() => this.exportar({}, 'EXCEL', true)}/>
							) : ''}
						</Fragment>
					}*/
					botonLISTA={
						<Fragment>
							<BotonActualizarLista onClick={() => {
								this.Listar();
							}}/>
						</Fragment>
					}
				/>
				<FiltrosProveedor
					AplicarFiltros={this.AplicarFiltros}
					HandleFiltro={this.HandleFiltro}
					showSnackBars={this.showSnackBars}
					ListBanco={this.ListBanco}
					ListAreaProyecto={this.ListAreaProyecto}
				/>
				
				<div className={'form margin-30-B'} style={{marginTop: '20px'}}>
					
					{this.state.listar_cuenta_bancaria.length > 0 ? (
						<Fragment>
							<ListaTabla
								lista={this.state.listar_cuenta_bancaria}
								RefreshList={this.RefreshList}
								showSnackBars={this.showSnackBars}
								ListProveedor={this.ListProveedor}
								ListBanco={this.ListBanco}
								ListAreaProyecto={this.ListAreaProyecto}
							/>
							<Paginacion
								total={this.state.paginacion.total}
								page={this.state.paginacion.page}
								limit={this.state.paginacion.limit}
								rangos={this.state.paginacion.rangos}
								onClick={(data) => this.AplicarPaginacion(data)}
							/>
						</Fragment>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<ModalProveedor
					tipo={'add'}
					item={{}}
					RefreshList={this.RefreshList}
					showSnackBars={this.showSnackBars}
					ListBanco={this.ListBanco}
					ListAreaProyecto={this.ListAreaProyecto}
				/>
			
			</div>
		);
	}
}

Proveedor.propTypes = {};

export default IntegrationNotistack(Proveedor);
